import * as React from 'react';

import './Input.scss';

interface Props extends React.ComponentProps<'input'> {
  placeholder?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name?: string;
  className?: string;
  id?: string;
  type?: string;
  onClick?: () => void;
}

const Input = (props: Props) => {
  return <input {...props} />;
};

export default Input;
